/**
 * Utility per mappare i Centri di Costo (CDC) agli Ambiti
 * Basato sui primi 2 caratteri del codice CDC
 */

export const SCOPES = [
  'AMMINISTRAZIONE',
  'DIPENDENZE',
  '0 - 18',
  'DISAGIO ADULTO',
  'SENIOR',
  'MIGRANTI',
  'RICEZIONE',
  'DIVERSA ABILITÀ',
  'AMBIENTE',
  'SPORT',
  'FORMAZIONE'
] as const;

export type Scope = typeof SCOPES[number];

// Mapping prefissi CDC → Ambito
// IMPORTANTE: Basato sui primi 2 NUMERI del codice CDC (es. "01", "02", "03")
// Stesso mapping usato nel backend Python (scope_analysis.py)
const CDC_PREFIX_TO_SCOPE: Record<string, Scope> = {
  '01': 'AMMINISTRAZIONE',
  '02': 'DIPENDENZE',
  '03': '0 - 18',
  '04': 'DISAGIO ADULTO',
  '05': 'SENIOR',
  '06': 'MIGRANTI',
  '07': 'RICEZIONE',
  '08': 'DIVERSA ABILITÀ',
  '09': 'AMBIENTE',
  '10': 'SPORT',
  '11': 'FORMAZIONE'
};

/**
 * Estrae l'ambito da un codice CDC basandosi sui primi 2 caratteri
 */
export function getScopeFromCdc(cdcCode: string): Scope | null {
  if (!cdcCode || cdcCode.length < 2) return null;
  
  const prefix = cdcCode.substring(0, 2).toUpperCase();
  return CDC_PREFIX_TO_SCOPE[prefix] || null;
}

/**
 * Filtra una lista di CDC per ambito
 */
export function filterCdcByScope(cdcList: any[], scope: Scope | null): any[] {
  if (!scope) return cdcList;
  
  return cdcList.filter(cdc => {
    const cdcScope = getScopeFromCdc(cdc.code);
    return cdcScope === scope;
  });
}

/**
 * Ottiene tutti i CDC appartenenti a un ambito
 */
export function getCdcCodesForScope(cdcList: any[], scope: Scope): string[] {
  return filterCdcByScope(cdcList, scope).map(cdc => cdc.code);
}

/**
 * Verifica se un CDC appartiene a un ambito
 */
export function cdcBelongsToScope(cdcCode: string, scope: Scope): boolean {
  const cdcScope = getScopeFromCdc(cdcCode);
  return cdcScope === scope;
}
